"use client";
import { useEffect, useState } from "react";
import Script from "next/script";
import { logError } from "@jetblue/dotcom-fe-logger";
import { functional } from "@jetblue/dotcom-trust-arc";

type MazeSnippetClientProperties = {
  readonly apiKey: string;
  readonly loaderUrl: string;
};

export const MazeSnippetClient = ({
  apiKey,
  loaderUrl,
}: MazeSnippetClientProperties) => {
  const [consent, setConsent] = useState(false);

  useEffect(() => {
    void (async () => {
      try {
        await functional();
        setConsent(true);
      } catch (error) {
        void logError({
          error,
          message: "Failed to resolve TrustArc consent decision for Maze",
        });
      }
    })();
  }, []);

  return consent ? (
    <Script id="maze-snippet" strategy="afterInteractive">
      {`(function (m, a, z, e) {
  var s, t, u, v;
  try { t = m.sessionStorage.getItem('maze-us'); } catch (err) {}
  if (!t) {
    t = new Date().getTime();
    try { m.sessionStorage.setItem('maze-us', t); } catch (err) {}
  }
  u = document.currentScript || (function () {
    var w = document.getElementsByTagName('script');
    return w[w.length - 1];
  })();
  v = u && u.nonce;
  s = a.createElement('script');
  s.src = z + '?apiKey=' + e;
  s.async = true;
  if (v) s.setAttribute('nonce', v);
  a.getElementsByTagName('head')[0].appendChild(s);
  m.mazeUniversalSnippetApiKey = e;
})(window, document, '${loaderUrl}', '${apiKey}');`}
    </Script>
  ) : null;
};
